var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import * as dateFns from 'date-fns';
import Divider from '../Divider';
import { useRef, useState } from 'react';
import DatePickerCalendar from './DatePicker.Calendar';
import DatePickerDefinedRanges from './DatePicker.DefinedRanges';
import DatePickerSelect from './DatePicker.Select';
import DatePickerSelectWithoutDateRange from './DatePicker.SelectWithoutRange';
import DatePickerStylesLoader from './DatePicker.StylesLoader';
var DatePickerWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var RANGE_KEY = 'selection';
var selectComponents = {
    withDate: DatePickerSelect,
    withoutDate: DatePickerSelectWithoutDateRange
};
var DatePicker = function (props) {
    var _a, _b;
    var _c = props.disableFutureDates, disableFutureDates = _c === void 0 ? false : _c, _d = props.withRange, withRange = _d === void 0 ? true : _d, _e = props.disabled, disabled = _e === void 0 ? false : _e, dateRange = props.dateRange, _f = props.showSelectWithDateRange, showSelectWithDateRange = _f === void 0 ? true : _f, onDateRangeSelect = props.onDateRangeSelect;
    var timeoutRef = useRef(0);
    var _g = useState(false), isOpen = _g[0], setIsOpen = _g[1];
    var _h = useState(dateFns.getTime((_a = dateRange.startDate) !== null && _a !== void 0 ? _a : new Date())), startDate = _h[0], setStartDate = _h[1];
    var _j = useState(dateFns.getTime((_b = dateRange.endDate) !== null && _b !== void 0 ? _b : new Date())), endDate = _j[0], setEndDate = _j[1];
    var rangeValues = {
        startDate: new Date(startDate),
        endDate: new Date(endDate)
    };
    var range = __assign({ key: RANGE_KEY }, rangeValues);
    var onRangeChange = function (rangeChange) {
        var _a, _b;
        if (disabled)
            return;
        setStartDate(dateFns.getTime((_a = rangeChange.startDate) !== null && _a !== void 0 ? _a : new Date()));
        setEndDate(dateFns.getTime((_b = rangeChange.endDate) !== null && _b !== void 0 ? _b : new Date()));
    };
    var onDateRangeSubmit = function () {
        if (disabled)
            return;
        onDateRangeSelect(rangeValues);
        setIsOpen(false);
    };
    var onCloseDatePicker = function () {
        setIsOpen(false);
        clearTimeout(timeoutRef.current);
        // reset date
        timeoutRef.current = window.setTimeout(function () {
            var _a, _b;
            setStartDate(dateFns.getTime((_a = dateRange.startDate) !== null && _a !== void 0 ? _a : new Date()));
            setEndDate(dateFns.getTime((_b = dateRange.endDate) !== null && _b !== void 0 ? _b : new Date()));
        }, 250);
    };
    var onOpenDatePicker = function () {
        if (disabled)
            return;
        setIsOpen(true);
    };
    var DatePickerSelectComponent = showSelectWithDateRange ? selectComponents.withDate : selectComponents.withoutDate;
    return (_jsx(DatePickerStylesLoader, { children: _jsx(DatePickerSelectComponent, __assign({ disabled: disabled, dateRange: rangeValues, isOpen: isOpen, onOpen: onOpenDatePicker }, { children: _jsxs(DatePickerWrapper, { children: [_jsx(DatePickerCalendar, { ranges: [range], rangeKey: RANGE_KEY, onRangeChange: onRangeChange, onDateRangeSubmit: onDateRangeSubmit, onCloseDatePicker: onCloseDatePicker, maxDate: disableFutureDates ? dateFns.endOfDay(new Date()) : undefined }), withRange && (_jsxs(_Fragment, { children: [_jsx(Divider, { margin: 0, orientation: "vertical" }), _jsx(DatePickerDefinedRanges, { disableFutureDates: disableFutureDates, rangeKey: RANGE_KEY, onRangeChange: onRangeChange, ranges: [range] })] }))] }) })) }));
};
export default DatePicker;
var templateObject_1;
